module.exports = __webpack_public_path__ + "img/ZB52_11.1e0ee788.jpg";